import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import { MultiSelectComponent } from '@progress/kendo-angular-dropdowns';
import _ from 'lodash';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';

@Component({
   selector: 'samweb-input-field',
   templateUrl: './input-field.component.html',
   styleUrls: ['./input-field.component.scss'],
})
export class InputFieldComponent implements OnInit, AfterViewInit {
   constructor(private elementRef: ElementRef) {}
   @Input()
   public icon: IconDefinition;

   @Input()
   public header: string;

   @Input()
   public value: string;

   @Input()
   public showWarning = false;

   @Input()
   public fadeIconOpacity = false;

   @Input()
   public swapIconOpacity = false;

   @Input()
   public disabled = false;

   @Input()
   public isFocused = false;

   @Input()
   public highlightIcon = false;

   @Input()
   public useAutocomplete = false;

   @Input()
   public autocompleteMatches: string[];

   @Input()
   public selectedEntries: string[] = [];

   @Output()
   public valueChanged = new EventEmitter();

   @Output()
   public valueChangedDebounced = new EventEmitter();

   @Output()
   public entrySelected = new EventEmitter();

   @Output()
   public unFocus = new EventEmitter();

   @ViewChild('multiselect')
   public multiselect: MultiSelectComponent;

   public clearFilterIcon: IconDefinition = WellKnownIconsEnum.CLEAR.iconSmall;

   ngOnInit(): void {}

   ngAfterViewInit(): void {
      const multiselectElement = this.elementRef.nativeElement.querySelector('kendo-multiselect');
      const divElement = multiselectElement?.querySelector('div');
      if (!_.isNil(divElement)) {
         divElement.style.border = 'none';
      }
   }

   textChanged(value: string) {
      if (!this.disabled) {
         this.valueChanged.emit(value);
      }
   }

   textChangedDebounced(value: string) {
      if (!this.disabled) {
         this.valueChangedDebounced.emit(value);
      }
   }

   clearText() {
      if (!this.disabled) {
         this.valueChanged.emit('');
         this.valueChangedDebounced.emit('');
      }
   }

   onMultiselectValueChange(selectedItems: string[]) {
      this.entrySelected.emit(selectedItems);
      this.cleanSearchbar();
   }

   changeMultiSelectSearchBar(value: string) {
      this.multiselect.searchbar.valueChange.emit(value);
   }

   onFocusOut(event: FocusEvent) {
      this.unFocus.emit(event);
   }

   cleanSearchbar() {
      this.changeMultiSelectSearchBar('');
      this.textChanged('');
      this.textChangedDebounced('');
   }
}
